import createClass from 'create-react-class';
import cIf from 'classnames';

// TODO : EventNotInSaleCustomMessage devra Ãªtre ajouter pour RESERVATECH.NET
// TODO : CanShowAdditionalDateNotificationListEnabled

// Uses window.tsapp
var ctl = tsapp.ctl;
var React = require("react");
var PT = require('prop-types');
var PropTypes = PT;
var up = require("ts-util").up;
var AjaxStateFeeder = require("ts-util").AjaxStateFeeder;
var tr = require('ts-translate-js').default.boundTR;
var trN = tr;
var Moment = require("moment");
var MarkDown = require("react-markdown");
var user = tsapp.user;
var tsRest = require('ts-rest-client');
var acnt = require('accounting');
var WaitingRoomLogicControl = require('tlm-waitingroom-client').WaitingRoomLogicControl;
var PeopleSuperVisual3DProgressPower = require('tlm-waitingroom-client').PeopleSuperVisual3DProgressPower;
var NumberSpinner = ctl.utilctl.NumberSpinner;
var PleaseWaitSpinner = ctl.utilctl.PleaseWaitSpinner;
var PlaceToGoEnum = ctl.utilctl.PlaceToGoEnum;
var AddToCartButtons = ctl.utilctl.AddToCartButtons;
var PageSection = ctl.utilctl.PageSection;


var testIFrameCookieSecurityIssue = ctl.utilctl.testIFrameCookieSecurityIssue;
var CookieSecurityWarningPanel = ctl.utilctl.CookieSecurityWarningPanel;
var retrieveIFramePosition = ctl.utilctl.retrieveIFramePosition;

var Modal = ctl.modal;

export const IntegratedRoomWidget = createClass({
    displayName: "IntegratedRoomWidget",

    propTypes: {
        roomId: PropTypes.string,
        roomUrl: PropTypes.string,
        personId: PropTypes.string,
        outUrl: PropTypes.string, // This gives the opportunity to the caller to pre-select a specific date in program mode.
        onContentChange: PropTypes.func
    },

    getInitialState: function () {
        return { readyToGo: false, iframeCookieIssue: testIFrameCookieSecurityIssue() };
    },

    
    componentDidMount: function() {
        this.raiseContentChanged();
    },

    componentDidUpdate: function () {
        this.raiseContentChanged(); // TODO : Devrait peut etre juste être triggered dans la fin du render avec un setTimeout....
    },
    
    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    
    onRedirectToSiteReady() {
        setTimeout(() => {
            window.location.replace(this.props.outUrl);
        }, 2000); // Just in case the browser won't auto redirect, we show a link on the page.

        this.setState({ readyToGo: true });
    },

    render() {

        var section = null;
        if(this.state.iframeCookieIssue) { // Fix IFrame security issue if apply (Safari, IPhone, IPad...)
            section = (
                <PageSection afterGetPosition={this.afterGetPositionControl}>
                    <CookieSecurityWarningPanel
                        cookiesverified={this.props.cookiesverified}
                        tsSiteDomain="https://www.reservatech.net"
                        siteInfo={this.state.siteInfo}  />
                </PageSection>
            ); // Unhardcode this someday...
        } else {
            section = (
                <PageSection>
                    <div>
                        <h3>{tr("File d'attente")}</h3>
                        
                        <WaitingRoomLogicControl
                            roomId={this.props.roomId}
                            personId={this.props.personId}
                            outUrl={this.props.outUrl}
                            roomServerUrl={this.props.roomUrl}
                            personIsReadyToGo={this.onRedirectToSiteReady}
                            readyToGo={this.state.readyToGo}
                            view={WaitingRoomView}
                        />                                
                    </div>                        
                </PageSection>
            );
        }            
        
        return (
            <div className={cIf(this.props.integ)}>
                {section}
            </div>
        );
    }
});

    // The View control
class WaitingRoomView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deactivatingPromo: false
        };
    }

    render() {
        var statusInfo;
        var waitingDetails;
        var stillAlive;
        
        if(this.props.readyToGo)
            statusInfo = <h4>{tr("Vous avez votre place! Nous vous transférons à cet") + " "} <a href={this.props.outUrl}>{tr("endroit...")}</a></h4>;
        else
            waitingDetails = [
                <h4 key="1">{tr("Ne pas actualiser cette page - Le système travaille pour vous!")}</h4>,
                <p key="2">
                    {tr("Laissez votre navigateur ouvert sur cette page et surveillez la. Lorsque votre tour sera venu, l'achat de billet apparaîtra. Prenez garde, actualiser cette page empêcherait votre navigateur de vérifier si le système vous a attribué une place.")}
                </p>
            ];
        
        if(this.props.showStillActiveReminder)
            stillAlive =
                <div>
                    <h4>{tr("Merci de patienter.")}</h4>
                    <p>{tr("Vous êtes toujours présent(e) dans la file d'attente et vous conserver votre priorité.")}</p>
                </div>;

        var productName = this.props.productName || this.props.organizationName;
        
        return (
            <div>
                <p>{tr("Vous êtes présentement dans la file d'attente d'accès à l'achat de billet.")}</p>
                
                <div className="row">
                        <div className="col-sm-6 col-sm-offset-3">
                            <PeopleSuperVisual3DProgressPower progressPercentage={this.props.progressPercentage} ></PeopleSuperVisual3DProgressPower>
                        </div>
                </div>

                {statusInfo}

                {stillAlive}
                
                {waitingDetails}

                
            </div>
        );
    }
}
WaitingRoomView.propTypes = {
    organizationName: PT.string,
    productName: PT.string,
    readyToGo: PT.bool,
    checkingStatus: PT.bool,
    redirectUrl: PT.string,
    showStillActiveReminder: PT.bool,
    lang: PT.string
};
